export const enum AttributeTypeNameValues {
    DaysToShip = "Days to Ship",    
}